import React, { useState } from 'react';
import '../../styles/AddCertificateModal.css';

function AddCertificateModal({ onClose, onAdd }) {
  const [name, setName] = useState('');
  const [issuer, setIssuer] = useState('');
  const [monthYear, setMonthYear] = useState('');
  const [link, setLink] = useState('');
  const [lessons, setLessons] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    onAdd({ name, issuer, monthYear, link, lessons });
  };

  return (
    <div className="add-certificate-modal">
      <div className="modal-content">
        <span className="close-button" onClick={onClose}>&times;</span>
        <h2>Add a new certificate</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name of the certificate</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Write the name of the certificate"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="issuer">Issuer of the certificate</label>
            <input
              type="text"
              id="issuer"
              value={issuer}
              onChange={(e) => setIssuer(e.target.value)}
              placeholder="Who gave you the certificate?"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="monthYear">Date of Issue (Month/Year)</label>
            <input
              type="text"
              id="monthYear"
              value={monthYear}
              onChange={(e) => setMonthYear(e.target.value)}
              placeholder="Write the date of issue of the certificate"
            />
          </div>
          <div className="form-group">
            <label htmlFor="link">Link to the certificate</label>
            <input
              type="url"
              id="link"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="Paste the link to your certificate"
            />
          </div>
          <div className="form-group">
            <label htmlFor="lessons">Major Lessons</label>
            <textarea
              id="lessons"
              value={lessons}
              onChange={(e) => setLessons(e.target.value)}
              placeholder="Write all the major lessons you got during the certification period"
            />
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default AddCertificateModal;